import React, { useState, useEffect } from "react";
import { Grid, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FarmerCard from "../../components/Custom/CustomCardFarmerList";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import Pagination from "@mui/material/Pagination";

export default function FPOFarmerDetails() {
  const { fpoId } = useParams();
  const { t } = useTranslation();
  const [fpoDetails, setFPODetails] = useState({});
  const [page, setPage] = useState(1);
  const [perPage] = useState(10); // Number of items per page

  useEffect(() => {
    api
      .get(`/fpo/get-fpo-details?fpoId=${fpoId}`)
      .then((response) => {
        setFPODetails(response.data);
      })
      .catch((error) => {
        console.error("Error fetching lenders:", error);
      });
  }, [fpoId]);

  const totalItems = fpoDetails?.farmers?.length || 0;
  const totalPages = Math.ceil(totalItems / perPage);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const startIndex = (page - 1) * perPage;
  const endIndex = page * perPage;

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid
          container
          justify="center"
          direction="column"
          style={{ marginTop: "10px" }}
        >
          <CustomTitle>{t("Farmer List")}</CustomTitle>

          <div
            style={{
              marginTop: "15px",
              height: "82vh",
              display: "flex",
              flexDirection: "column",
              width: "100%",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "100%", height: "95%", overflowY: "scroll" }}>
              {fpoDetails?.farmers
                ?.slice(startIndex, endIndex)
                .map((farmer) => (
                  <FarmerCard
                    key={farmer.farmer_id}
                    farmer={{
                      app_user: { full_name: farmer.full_name },
                    }}
                    t={t}
                    buttons
                    detailsDropDown={[
                      {
                        label: t("Farmer Name"),
                        value: `${farmer.full_name}`,
                      },
                      { label: t("Land Area"), value: "NA" },
                      { label: t("Phone Number"), value: "NA" },
                      { label: t("Email ID"), value: "NA" },
                      { label: t("Taluka"), value: "NA" },
                      { label: t("Village"), value: "NA" },
                      { label: t("State"), value: "NA" },
                      { label: t("District"), value: "NA" },
                    ]}
                  />
                ))}
            </div>

            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              sx={{
                "& .Mui-selected": {
                  color: "green",
                  borderBottom: "1px solid green",
                  borderRadius: 0,
                  backgroundColor: "transparent",
                },
                "& .MuiPaginationItem-icon": {
                  color: "green",
                  fontSize: "30px",
                },
              }}
            />
          </div>
        </Grid>
      </Container>
    </>
  );
}
